import { browserHistory } from 'react-router';

/**
 * general class to do HTTP related things
 * @type {Object}
 */
let oauthSignature = require('oauth-signature');
let globalConfig = require('Config');
let Quote =  require('../Managers/Quote');
const CryptoJS = require("crypto-js");
const blobUtil = require('blob-util');

const request = require('superagent');

module.exports = {
    getConfigForHost() {
        let envConfig;
        switch (window.location.host) {
            case globalConfig.liveHostHomelet:
                envConfig = globalConfig.prodHomelet;
                break;
            case globalConfig.liveHostRentshield:
                envConfig = globalConfig.prodRentshield;
                break;
            case globalConfig.staging1Host:
                envConfig = globalConfig.staging1;
                break;
            case globalConfig.staging2Host:
                envConfig = globalConfig.staging2;
                break;
            case globalConfig.stagingHostRentshield:
                envConfig = globalConfig.stagingRentshield;
                break;
            case globalConfig.trainingHost:
                envConfig = globalConfig.training;
                break;
            default:
                envConfig = globalConfig.staging1;
                break;
        }
        return envConfig;
    },

    /**
     * given a length, generate a auth nonce of that length
     * a nonce is random characters taken a-z,A-Z,0-9
     *
     * @param  {int} length
     * @return {string}
     */
    generateNonce(length) {
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for(let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    },

    /**
     * given the correct parameters, build an Oauth 1 header that can be injected into a request
     *
     * @param  {string} consumerKey
     * @param  {string} nonce
     * @param  {string} signature
     * @param  {string} timestamp
     * @return {string} the built header
     */
    buildOauthHeader(consumerKey, nonce, signature, timestamp) {
        return 'OAuth oauth_consumer_key="' + String(consumerKey) + '",oauth_signature_method="HMAC-SHA1",oauth_timestamp="' + String(timestamp) + '",oauth_nonce="' + String(nonce) + '",oauth_version="1.0",oauth_signature="' + String(signature) + '"';
    },

    /**
     * given a key, a secret, and an optional timestmap,
     * return a fully generated and formatted Authorisation header value
     * for Oauth1 content
     *
     * @param  {string} key
     * @param  {string} secret
     * @param  {string} timestamp if none given, use the current time
     * @return {string}
     */
    generateOauth1Header(method, key, secret, uri, timestamp) {
        if (window.uorn(key)) {
            throw ("generateOauth1Header() called without a key");
        }
        if (window.uorn(secret)) {
            throw ("generateOauth1Header() called without a secret");
        }
        let nonce = this.generateNonce(6);

        if (window.uorn(timestamp)) {
            timestamp = + new Date();
            timestamp = parseInt(timestamp / 1000);
        }

        let sig = decodeURIComponent(oauthSignature.generate(
            method,
            uri,
            {
                oauth_consumer_key : key,
                oauth_nonce : nonce,
                oauth_timestamp : timestamp,
                oauth_signature_method : 'HMAC-SHA1',
                oauth_version : '1.0',
            },
            secret
        ));

        return this.buildOauthHeader(key, nonce, sig, timestamp);
    },

    generateOauth1QueryParams(method, key, secret, uri, queryParams, timestamp) {
        let nonce = this.generateNonce(6);

        if (window.uorn(timestamp)) {
            timestamp = + new Date();
            timestamp = parseInt(timestamp / 1000);
        }

        if (window.uorn(queryParams)) {
            queryParams = {};
        }

        let sig = oauthSignature.generate(
            method,
            uri,
            Object.assign({}, {
                oauth_consumer_key : String(key),
                oauth_nonce : String(nonce),
                oauth_timestamp : String(timestamp),
                oauth_signature_method : 'HMAC-SHA1',
                oauth_version : '1.0',
            }, queryParams),
            secret
        );

        let queryString = '';
        queryString += "oauth_consumer_key=" + String(key);
        queryString += "&oauth_signature_method=HMAC-SHA1";
        queryString += "&oauth_timestamp=" + String(timestamp);
        queryString += "&oauth_nonce=" + String(nonce);
        queryString += "&oauth_version=1.0";
        queryString += "&oauth_signature=" + decodeURIComponent(sig);
        // queryString += "&oauth_signature=" + String(sig);

        return queryString;
    },

    /**
     * Returns the application number for the given application uuid against the
     * tenant index provided
     *
     * @param applicationId
     * @param tenantIndex
     * @returns {Promise}
     */
    getApplicationNumber(applicationId, tenantIndex) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.getapplicantapplication.url;
        url = url.replace('{applicationId}', applicationId);

        let oauth = this.getAgentKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('GET', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data.referenceNumber);
                    Quote.setByPath('BaseIndividualApplication_' + tenantIndex + '.referenceNumber', data.referenceNumber);
                },
                error: function() {
                    reject("GET APPLICATION ERROR");
                }
            }).fail(function(){
                reject("GET APPLICATION AJAX FAIL");
            });
        });
    },

    /**
     * call the create case function. upon completion, call the
     * application create function as many times as necessary. once
     * all those promises are fulfilled, call the case submission. once
     * case submission has fulfilled, return a Promise.resolve()
     *
     * @return {Promise}
     */
    agentEmailToTenantProcess() {
        let caseId = null;
        let numTenants = null;

        return this.postValidateCase()
        .then(() => {
            return this.postCreateCase();
        })
        .then(caseData => {
            let validationPromises = [];
            caseId = caseData.caseId;
            numTenants = Quote.getByPath('Case', 'numberOfTenants');

            if (numTenants === null) {
                numTenants = 1;
            }
            for (let tenantIndex = 1; tenantIndex <= numTenants; tenantIndex++) {
                validationPromises.push(this.postValidateApplication(caseId, tenantIndex));
            }
            return Promise.all(validationPromises);
        })
        .then(() => {
            let createPromises = [];
            for (let tenantIndex = 1; tenantIndex <= numTenants; tenantIndex++) {
                createPromises.push(this.postCreateApplication(caseId, tenantIndex));
            }
            return Promise.all(createPromises);
        })
        .then(() => {
            let createPromises = [];
            for (let tenantIndex = 1; tenantIndex <= numTenants; tenantIndex++) {
                createPromises.push(this.getApplicationNumber(Quote.getByPath('BaseIndividualApplication_' + tenantIndex + '.applicationId'), tenantIndex));
            }
            return Promise.all(createPromises);
        })
        .then(() => {
            return this.putSubmitCase(caseId);
        })
        .then(() => {
            return Promise.resolve(true);
        })
        .catch(invalidData => {
            return Promise.reject(invalidData);
        });
    },

    /**
     * Takes an application uuid in order to create the guarantor application
     * and submit it with a completionMethod of 'dynamic form', redirecting the
     * user to the 'applicant submitted' screen.
     */
    agentEmailToGuarantorProcess() {
        let applicationId = window.localStorage.getItem('applicationId');
        Quote.set('completionMethod', 3, 'BaseIndividualApplication');
        this.postCreateGuarantor(applicationId)
        .then((data) => {
            return this.putSubmitNewApplication(data.applicationId);
        })
        .then(() => {
            browserHistory.push('/case/applicant-submitted');
        });
    },

    /**
     * Takes an application uuid in order to create the guarantor application
     * and then submit it, before redirecting the user back to Connect.
     *
     * @param applicationId
     */
    createGuarantorRedirectToConnect() {
        let envConfig = this.getConfigForHost();
        let applicationId = window.localStorage.getItem('applicationId');
        let url = envConfig.connectLandingAddGuarantor.url;
        Quote.set('completionMethod', 1, 'BaseIndividualApplication');
        this.postCreateGuarantor(applicationId)
        .then((data) => {
            url = url.replace('{applicationId}', data.applicationId);
            window.location.assign(url);
        });
    },

    /**
     * call the create case function. upon completion, call the
     * application create function as many times as necessary. once
     * all those promises are fulfilled, return a Promise.resolve()
     *
     * @return {Promise}
     */
    agentCompleteNowProcess() {
        let caseId = null;
        let numTenants = null;

        return this.postValidateCase()
        .then(() => {
            return this.postCreateCase();
        })
        .then(caseData => {
            caseId = caseData.caseId;
            numTenants = Quote.getByPath('Case', 'numberOfTenants');
            let createPromises = [];
            if (numTenants === null) {
                numTenants = 1;
            }
            for (let tenantIndex = 1; tenantIndex <= numTenants; tenantIndex++) {
                createPromises.push(this.postCreateApplication(caseId, tenantIndex));
            }
            return Promise.all(createPromises);
        })
        .then(() => {
            return Promise.resolve(true);
        })
        .catch(invalidData => {
            return Promise.reject(invalidData);
        });
    },

    agentGeneralisedSubmitProcess(completeFunction, invalidFunction) {
        let caseId = null;
        let numTenants = null;

        let applications = [];

        this.postValidateCase()
        .then(() => {
            return this.postCreateCase();
        })
        .then(caseData => {
            // build an array of applications
            caseId = caseData.caseId;
            numTenants = Quote.getByPath('Case', 'numberOfTenants');
            if (numTenants === null) {
                numTenants = 1;
            }
            for (let tenantIndex = 1; tenantIndex <= numTenants; tenantIndex++) {
                if (window.localStorage.getItem('BaseIndividualApplication_' + tenantIndex)) {
                    applications.push(JSON.parse(window.localStorage.getItem('BaseIndividualApplication_' + tenantIndex)));
                }
            }

            return Promise.resolve(true);
        })
        .then(() => {
            // validate all the e2t applications
            let validationPromises = [];

            applications.map((app, i) => {
                if (app.completionMethod == 3) {
                    validationPromises.push(this.postValidateApplication(caseId, i + 1));
                } else {
                    validationPromises.push(Promise.resolve(true));
                }
            });

            return Promise.all(validationPromises);
        })
        .then(() => {
            // then we create all the e2t applications
            let createPromises = [];
            applications.map((app, i) => {
                if (app.completionMethod == 3) {
                    createPromises.push(this.postCreateApplication(caseId, i + 1));
                } else {
                    createPromises.push(Promise.resolve(true));
                }
            });
            return Promise.all(createPromises);
        })
        .then(() => {
            // then we submit the case ONLY IF WE HAVE AT LEAST 1 EMAIL TO TENANT
            let shouldSubmit = false;
            applications.map(app => {
                if (app.completionMethod == 3) {
                    shouldSubmit = true;
                }
            });

            if (shouldSubmit) {
                return this.putSubmitCase(caseId);
            }
        })
        .then(() => {
            // then we create the complete now applications
            let createPromises = [];
            applications.map((app, i) => {
                if (app.completionMethod == 1) {
                    createPromises.push(this.postCreateApplication(caseId, i + 1));
                } else {
                    createPromises.push(Promise.resolve(true));
                }
            });
            return Promise.all(createPromises);
        })
        .then(() => {
            // then we get the referenceNumber for each applicant to display on
            // the 'case submitted' page.
            let createPromises = [];
            for (let tenantIndex = 1; tenantIndex <= numTenants; tenantIndex++) {
                createPromises.push(this.getApplicationNumber(Quote.getByPath('BaseIndividualApplication_' + tenantIndex + '.applicationId'), tenantIndex));
            }
            return Promise.all(createPromises);
        })
        .then(() => {
            if (completeFunction) {
                completeFunction();
            }
        })
        .catch(invalidData => {
            if (invalidFunction) {
                invalidFunction(invalidData);
            }
        });
    },

    /**
     * call the edit application function (which uses the data in local storage)
     * once that has completed, call the submit application function
     *
     * @return {Promise}
     */
    applicationPutApplicationAndSubmit() {
        return Quote.fudgeRefereeTelephoneNumbers()
        .then(() => {
            // we only need to validate the application
            // if they're a tenant
            let applicationType = Quote.get('applicationType', 'BaseIndividualApplication');
            let applicationId = window.localStorage.getItem('applicationId');
            if (applicationType == 1) {
                return this.postValidateApplication(Quote.get('caseId', 'BaseIndividualApplication'));
            } else if (applicationType == 2) {
                return this.postValidateGuarantor(applicationId);
            }
        })
        .then(() => {
            return this.putEditApplication(this.getLinkRef());
        })
        .then(() => {
            // after putting the application, put the notes
            return this.postCreateApplicationNote(window.localStorage.getItem('applicationId'));
        })
        .then(() => {
            return this.putSubmitApplication(window.localStorage.getItem('applicationId'));
        });
    },

    /**
     * save the data for an application without submitting it
     * primarily used for the "Save for Later" functionality
     *
     * @return {Promise}
     */
    applicationPutApplication(completeFunction, invalidFunction) {
        return Quote.fudgeRefereeTelephoneNumbers()
        // when saving for later, we dont wanna validate - its perfectly legit that
        // saving for later is happening against an incomplete quote
        // .then(() => {
        //     return this.postValidateApplication(Quote.get('caseId', 'BaseIndividualApplication'));
        // })
        .then(() => {
            return this.putEditApplication(this.getLinkRef());
        })
        .then(() => {
            return this.postCreateApplicationNote(window.localStorage.getItem('applicationId'));
        })
        .then(() => {
            if (completeFunction) {
                completeFunction();
            }
        })
        .catch(invalidData => {
            if (invalidFunction) {
                invalidFunction(invalidData);
            }
        });
    },

    validateTenantCreateTenant(caseId) {
        this.postValidateApplication(Quote.get('caseId', 'BaseIndividualApplication'))
        .then(() => {
            return this.postCreateApplication(caseId);
        })
        .then(() => {
            browserHistory.push('/case/submitted');
        });
    },

    validateNewTenantCreateNewTenant(caseId) {
        this.postValidateApplication(Quote.get('caseId', 'BaseIndividualApplication'))
        .then(() => {
            return this.postCreateApplication(caseId);
        })
        .then((data) => {
            return this.putSubmitNewApplication(data.applicationId);
        })
        .then(() => {
            browserHistory.push('/case/applicant-submitted');
        });
    },

    validateTenantCreateTenantRedirectToConnect(caseId, tenantIndex) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.connectLandingAddTenant.url;
        this.postValidateApplication(window.localStorage.getItem('caseId'))
        .then(() => {
            return this.postCreateApplication(caseId, tenantIndex);
        })
        .then((data) => {
            Quote.set('completionMethod', 1, 'BaseIndividualApplication');
            url = url.replace('{applicationId}', data.applicationId);
            window.location.assign(url);
        });
    },

    postCreateCase() {
        let envConfig = this.getConfigForHost();
        let oauth = this.getAgentKeyAndSecret();

        let caseData = JSON.parse(window.localStorage.getItem('Case'));

        if (window.uorn(caseData.propertyType))  {
            // @NOTE this is "unknown" or "other"
            caseData.propertyType = 6;
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: JSON.stringify(caseData),
                url: envConfig.setcase.url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, envConfig.setcase.url),
                },
                success: function(data) {
                    Quote.set('caseId', data.caseId, 'Case');
                    resolve({
                        caseId: data.caseId
                    });
                },
                error: function() {
                    reject("POST CASE ERROR");
                }
            }).fail(function(){
                reject("POST CASE FAIL");
            });
        });
    },

    postCreateApplication(caseId, applicationIndex) {
        let envConfig = this.getConfigForHost();
        let localStorageKey = 'BaseIndividualApplication';

        if (!window.uorn(applicationIndex)) {
            localStorageKey += '_' + String(applicationIndex);
        }

        let url = envConfig.setapplicant.url;
        url = url.replace('{caseId}', caseId);

        let oauth = this.getAgentKeyAndSecret();

        // if we have an applicationId, set it to null
        let application = JSON.parse(window.localStorage.getItem(localStorageKey));
        if (application.applicationId) {
            application.applicationId = null;
        }

        // if we have an agent mobile number, inject it
        if (!window.uorn(Quote.getByPath('Case.agentMobile'))) {
            application.agentMobile = Quote.getByPath('Case.agentMobile');
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: JSON.stringify(application),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    Quote.set('applicationId', data.applicationId, localStorageKey);
                    resolve(data);
                },
                error: function() {
                    reject("POST APPLICATION ERROR");
                }
            });
        });
    },

    postCreateGuarantor(applicationId) {
        let envConfig = this.getConfigForHost();
        let localStorageKey = 'BaseIndividualApplication';

        let url = envConfig.setguarantor.url;
        url = url.replace('{applicationId}', applicationId);

        let oauth = this.getAgentKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: window.localStorage.getItem(localStorageKey),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("POST APPLICATION ERROR");
                }
            });
        });
    },

    putEditApplication(linkref) {
        let envConfig = this.getConfigForHost();
        // Nullify applicationId to prevent any IRIS conflicts.
        Quote.set('applicationId', null, 'BaseIndividualApplication');
        let url = envConfig.editapplicant.url;
        url = url.replace('{linkRef}', linkref);

        //we pull it out as we edit it below
        let applicationChunk = JSON.parse(window.localStorage.getItem('BaseIndividualApplication'));

        let oauth = this.getSystemKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'PUT',
                data: JSON.stringify(applicationChunk),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('PUT', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("PUT APPLICATION ERROR");

                    Quote.setByPath('Error.linkRef', linkref);
                    Quote.setByPath('Error.endPoint', url);

                    if (location.pathname === '/error/save-application-details') {
                        window.location.reload();
                    } else {
                        browserHistory.push('/error/save-application-details');
                    }
                }
            });
        });
    },

    /**
     * Logs an error message though an API endpoint.
     *
     * @param message
     * @returns {Promise}
     */
    logError(message) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.postError.url;
        let errorData = {
            "msg": message,
            "app": "referencingSPA"
        };

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: JSON.stringify(errorData),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "X-API-KEY": envConfig.postError.key,
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("FAILED LOGGING ERROR");
                }
            });
        });
    },

    /**
     * Uses the config endpoint for getting the user agent IP to store it in
     * localStorage where required.
     *
     * @param saveTo
     */
    getIp(saveTo) {
        let url = globalConfig.ipLookup.url;

        $.ajax({
            type: 'GET',
            url: url,
            crossDomain: true,
            headers: {
                "x-api-key": "7oNbll3cG26tFSBQ7l4gL65DdllHCNvLaBOLgSgt"
            },
            success: function(data) {
                Quote.setByPath(saveTo, data.ip);
            }
        });
    },

    postReferee(linkref, type) {
        let envConfig = this.getConfigForHost();
        let url;

        // Filter based on the type of referee we're posting - same
        // requirements, but different URLs.
        switch(type) {
            case 'letting':
                url = envConfig.postLettingReferee.url;
                break;
            case 'employer':
                url = envConfig.postEmployedReferee.url;
                break;
            case 'self-employed':
                url = envConfig.postSelfEmployedReferee.url;
                break;
            case 'retired':
                url = envConfig.postRetiredReferee.url;
                break;
            default:
                url = envConfig.postEmployedReferee.url;
                break;
        }

        url = url.replace('{linkRef}', linkref);

        let refereeChunk = JSON.parse(window.localStorage.getItem('Referee'));

        let oauth = this.getSystemKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: JSON.stringify(refereeChunk),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                    browserHistory.push('/referee-request/submitted');
                },
                error: function() {
                    reject("PUT APPLICATION ERROR");

                    if (location.pathname === '/error/save-referee-details') {
                        window.location.reload();
                    } else {
                        browserHistory.push('/error/save-referee-details');
                    }
                }
            });
        });
    },

    putSubmitCase(caseId) {
        let envConfig = this.getConfigForHost();
        let submitCaseUrl = envConfig.submitcase.url;
        submitCaseUrl = submitCaseUrl.replace('{caseId}', caseId);

        let oauth = this.getAgentKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'PUT',
                data: {},
                url: submitCaseUrl,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('PUT', oauth.key, oauth.secret, submitCaseUrl),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("PUT SUBMIT CASE ERROR");
                }
            }).fail(function(){
                reject("PUT CASE FAIL");
            });
        });
    },

    putSubmitApplication(applicationId) {
        let envConfig = this.getConfigForHost();
        let submitApplicationUrl = envConfig.submitapplicant.url;
        submitApplicationUrl = submitApplicationUrl.replace('{applicationId}', applicationId);

        let oauth = this.getSystemKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'PUT',
                data: {},
                url: submitApplicationUrl,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('PUT', oauth.key, oauth.secret, submitApplicationUrl),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function(xhr) {
                    if (xhr.status == 422 || xhr.status == 0) {
                        browserHistory.push('/application/submitted');
                    } else {
                        reject("PUT SUBMIT APPLICATION ERROR");
                        if (location.pathname === '/error/submit-application') {
                            window.location.reload();
                        } else {
                            browserHistory.push('/error/submit-application');
                        }
                    }
                }
            }).fail(function(){
                reject("PUT APPLICATION FAIL");
            });
        });
    },

    putSubmitNewApplication(applicationId) {
        let envConfig = this.getConfigForHost();
        let submitApplicationUrl = envConfig.submitnewapplicant.url;
        submitApplicationUrl = submitApplicationUrl.replace('{applicationId}', applicationId);

        let oauth = this.getAgentKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'PUT',
                data: {},
                url: submitApplicationUrl,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('PUT', oauth.key, oauth.secret, submitApplicationUrl),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("PUT SUBMIT APPLICATION ERROR");
                }
            }).fail(function(){
                reject("PUT APPLICATION FAIL");
            });
        });
    },

    getRetrieveApplication(linkref) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.getapplicant.url;

        url = url.replace('{linkRef}', linkref);

        let oauth = this.getSystemKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('GET', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("GET APPLICATION ERROR");
                }
            }).fail(function(){
                reject("GET APPLICATION AJAX FAIL");
            });
        });
    },

    getRetrieveCase(caseId) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.getcase.url;

        url = url.replace('{caseId}', caseId);

        let oauth = this.getSystemKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('GET', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("GET APPLICATION ERROR");
                }
            }).fail(function(){
                reject("GET APPLICATION AJAX FAIL");
            });
        });
    },

    postCreateApplicationNote(applicationId) {
        let envConfig = this.getConfigForHost();
        let note = Quote.getByPath('ApplicationNote', 'note');

        if (window.uornorb(note)) {
            return Promise.resolve(true);
        }

        let oauth = this.getSystemKeyAndSecret();

        let url = envConfig.setApplicationNote.url;
        url = url.replace('{applicationId}', applicationId);

        let applicationNote = window.localStorage.getItem('ApplicationNote');

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: applicationNote,
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("POST APPLICATION NOTE ERROR");

                    if (location.pathname === '/error/save-notes') {
                        window.location.reload();
                    } else {
                        browserHistory.push('/error/save-notes');
                    }
                }
            }).fail(function(){
                reject("POST APPLICATION NOTE FAIL");
            });
        });
    },

    getRetrieveAgentBranch(linkref) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.getagentbranch.url;
        url = url.replace('{linkRef}', linkref);

        let oauth = this.getSystemKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('GET', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("GET AGENT BRANCH ERROR");
                }
            }).fail(function(){
                reject("GET AGENT BRANCH AJAX FAIL");
            });
        });
    },

    /**
     * Gets the dynamic legal texts for a given linkref for system (applicant)
     * endpoints.
     *
     * @param linkref
     * @returns {Promise}
     */
    getPrivateLegalTexts(linkref) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.getPrivateTerms.url;
        url = url.replace('{linkRef}', linkref);

        let oauth = this.getSystemKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('GET', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    window.localStorage.setItem('domainInfo', JSON.stringify(data));
                    resolve(data);
                },
                error: function() {
                    reject("GET TERMS AND CONDITIONS ERROR - PRIVATE");
                }
            }).fail(function(){
                reject("GET TERMS AND CONDITIONS AJAX FAIL - PRIVATE");
            });
        });
    },

    /**
     * Gets the dynamic legal texts for for the current (agent) user.
     *
     * @param linkref
     * @returns {Promise}
     */
    getPublicLegalTexts() {
        let envConfig = this.getConfigForHost();
        let url = envConfig.getPublicTerms.url;

        let oauth = this.getAgentKeyAndSecret();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('GET', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    window.localStorage.setItem('domainInfo', JSON.stringify(data));
                    resolve(data);
                },
                error: function() {
                    reject("GET TERMS AND CONDITIONS ERROR - PUBLIC");
                }
            }).fail(function(){
                reject("GET TERMS AND CONDITIONS AJAX FAIL - PUBLIC");
            });
        });
    },

    setAgentHash(hash) {
        window.localStorage.setItem('agentHash', hash);
    },

    getAgentKeyAndSecret() {
        const hash = window.localStorage.getItem('agentHash');

        // Only process if there is a hash
        if( ! window.uornorb(hash)) {
            let bytes = CryptoJS.AES.decrypt(atob(hash), globalConfig.app.mcryptSecret);
            let decodedHash = bytes.toString(CryptoJS.enc.Utf8);

            let hashComponents = decodedHash.split('&');
            const key = hashComponents[0].replace('consumerKey=', '');
            const secret = hashComponents[1].replace('consumerSecret=', '');

            return {
                key,
                secret
            };
        } else {
            browserHistory.push('/error/no-auth');
        }
    },

    getSystemKeyAndSecret() {
        return {
            key: globalConfig.app.systemApiKey,
            secret: globalConfig.app.systemApiSecret,
        };
    },

    setLinkRef(linkref) {
        window.localStorage.setItem('linkref', linkref);
    },

    getLinkRef() {
        return window.localStorage.getItem('linkref');
    },

    /**
     * Gets the BankValidationStrategy from the bank data API and saves it to
     * localStorage for later use in the application - should the applicant meet
     * the criteria for us to show it.
     *
     * @returns {Promise}
     */
    getBankValidationStrategy() {
        let envConfig = this.getConfigForHost();
        let applicationId = Quote.getByPath('BaseIndividualApplication.referenceNumber').toString().substring(3,10);
        let uuid = window.localStorage.getItem('applicationId');

        let domainId = 1;
        let strategyId = window.localStorage.getItem('BankDataProvider');

        let url = envConfig.getBankStrategy.url;
        url = url.replace('{domainId}', domainId);
        url = url.replace('{strategyId}', strategyId);
        url = url.replace('{applicationId}', applicationId);
        url = url.replace('{uuid}', uuid);

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                },
                success: function(data) {
                    window.localStorage.setItem('BankValidationStrategy', JSON.stringify(data));
                    resolve(data);
                },
                error: function() {
                    reject("GET BANK VALIDATION STRATEGY ERROR");
                }
            }).fail(function(){
                reject("GET BANK VALIDATION STRATEGY FAIL");
            });
        });
    },

    postValidateCase() {
        let envConfig = this.getConfigForHost();
        let oauth = this.getSystemKeyAndSecret();

        let caseData = JSON.parse(window.localStorage.getItem('Case'));

        if (window.uorn(caseData.propertyType)) {
            // @NOTE this is "unknown" or "other"
            caseData.propertyType = 6;
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: JSON.stringify(caseData),
                url: envConfig.validateCase.url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, envConfig.validateCase.url),
                },
                success: function(data) {
                    if (data.valid) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                },
                error: function() {
                    reject("VALIDATE CASE ERROR");
                }
            }).fail(function(){
                reject("VALIDATE CASE FAIL");
            });
        });
    },

    postValidateApplication(caseId, tenantIndex) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.validateApplication.url;
        url = url.replace('{caseId}', caseId);

        let oauth = this.getSystemKeyAndSecret();

        // allow the validation of applications from
        // either permutation
        let localStorageKey = 'BaseIndividualApplication';
        if (tenantIndex !== null && tenantIndex !== undefined) {
            localStorageKey += '_' + String(tenantIndex);
        }

        // if we have an applicationId, set it to null
        let application = JSON.parse(window.localStorage.getItem(localStorageKey));
        if (application.applicationId) {
            application.applicationId = null;
        }

        let linkRef = window.localStorage.getItem('linkref');
        if (!window.uornorb(linkRef)) {
            application.formLinkUuid = linkRef;
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: JSON.stringify(application),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    if (data.valid) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                },
                error: function() {
                    reject("VALIDATE APPLICATION ERROR");

                    Quote.setByPath('Error.linkRef', window.localStorage.getItem('linkref'));
                    Quote.setByPath('Error.endPoint', url);

                    if (location.pathname === '/error/applicant-validation') {
                        window.location.reload();
                    } else {
                        browserHistory.push('/error/applicant-validation');
                    }
                }
            }).fail(function(){
                reject("VALIDATE APPLICATION FAIL");
            });
        });
    },

    postValidateGuarantor(applicationId) {
        let envConfig = this.getConfigForHost();
        let url = envConfig.validateGuarantor.url;
        url = url.replace('{applicationId}', applicationId);

        let oauth = this.getSystemKeyAndSecret();

        // allow the validation of applications from
        // either permutation
        let localStorageKey = 'BaseIndividualApplication';

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: window.localStorage.getItem(localStorageKey),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    if (data.valid) {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                },
                error: function() {
                    reject("VALIDATE GUARANTOR ERROR");
                }
            }).fail(function(){
                reject("VALIDATE GUARANTOR FAIL");
            });
        });
    },

    postUploadDocument(applicationId, file, description) {
        let envConfig = this.getConfigForHost();
        let oauth = this.getSystemKeyAndSecret();

        let url = envConfig.documentUpload.url;
        url = url.replace('{applicationId}', applicationId);

        return new Promise((resolve, reject) => {
            let req = request.post(url);
            req.set("Authorization", this.generateOauth1Header('POST', oauth.key, oauth.secret, url));
            req.set('X-Requested-With', 'XMLHttpRequest');
            req.field('description', description);
            req.field('fileName', file.name);
            req.field('category', 3);
            req.attach("file", file);
            return req.end((err, res) => {
                if (err) {
                    reject("DOCUMENT UPLOAD FAILED");
                    if (location.pathname === '/error/file-upload-failed') {
                        window.location.reload();
                    } else {
                        browserHistory.push('/error/file-upload-failed');
                    }
                } else {
                    resolve(res);
                }
            });
        });
    },

    /**
     * Soft deletes a specified file by telling IRIS to detach it from the
     * application.
     *
     * @param applicationId
     * @param file
     * @returns {Promise}
     */
    postDetachDocument(applicationId, file) {
        let envConfig = this.getConfigForHost();
        let oauth = this.getSystemKeyAndSecret();
        let fileName = window.encodeURI(file.name);

        let url = envConfig.documentDetach.url;
        url = url.replace('{applicationId}', applicationId);
        url = url.replace('{fileName}', fileName);

        return new Promise((resolve, reject) => {
            let req = request.post(url);
            req.set("Authorization", this.generateOauth1Header('POST', oauth.key, oauth.secret, url));
            req.set('X-Requested-With', 'XMLHttpRequest');
            return req.end((err, res) => {
                if (err) {
                    reject("DOCUMENT DELETION FAILED");
                    if (location.pathname === '/error/file-upload-failed') {
                        window.location.reload();
                    } else {
                        browserHistory.push('/error/file-upload-failed');
                    }
                } else {
                    resolve(res);
                }
            });
        });
    },

    postSaveFinancialReferee(tokenId, index) {
        let envConfig = this.getConfigForHost();
        let oauth = this.getSystemKeyAndSecret();

        let referee = JSON.parse(window.localStorage.getItem('EmploymentFinancialReferee'));

        let url = envConfig.saveFinancialReferee.url;
        url = url.replace('{tokenUuid}', tokenId);
        url = url.replace('{refereeType}', index);

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: JSON.stringify(referee),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('POST', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject();
                }
            }).fail(function(){
                reject();
            });
        });
    },

    getRetrieveFinancialReferee(tokenId, financialRefereeStatus) {
        let envConfig = this.getConfigForHost();
        let oauth = this.getSystemKeyAndSecret();

        let url = envConfig.saveFinancialReferee.url;
        url = url.replace('{tokenUuid}', tokenId);
        url = url.replace('{refereeType}', financialRefereeStatus);

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header('GET', oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("RETRIEVE FINANCIAL REFEREE ERROR");
                }
            }).fail(function(){
                reject("RETRIEVE FINANCIAL REFEREE FAIL");
            });
        });
    },

    // @TODO this needs to be done
    postSaveLettingReferee(tokenId) {
        let envConfig = this.getConfigForHost();
        let oauth = this.getSystemKeyAndSecret();

        let referee = JSON.parse(window.localStorage.getItem('EmploymentLettingReferee'));

        let url = envConfig.saveLettingReferee.url;
        url = url.replace('{tokenUuid}', tokenId);

        return new Promise((resolve, reject) => {
            $.ajax({
                type: envConfig.saveLettingReferee.method,
                data: JSON.stringify(referee),
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header(envConfig.saveLettingReferee.method, oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("SAVE LETTING REFEREE ERROR");
                }
            }).fail(function(){
                reject("SAVE LETTING REFEREE FAIL");
            });
        });
    },

    getRetrieveLettingReferee(tokenId) {
        let envConfig = this.getConfigForHost();
        let oauth = this.getSystemKeyAndSecret();

        let url = envConfig.retrieveLettingReferee.url;
        url = url.replace('{tokenUuid}', tokenId);

        return new Promise((resolve, reject) => {
            $.ajax({
                type: envConfig.retrieveLettingReferee.method,
                url: url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.generateOauth1Header(envConfig.retrieveLettingReferee.method, oauth.key, oauth.secret, url),
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("RETRIEVE LETTING REFEREE ERROR");
                }
            }).fail(function(){
                reject("RETRIEVE LETTING REFEREE FAIL");
            });
        });
    },

    /**
     * build a query string from a key-value JSON object
     * @param  {object} queryParams
     * @return {string} ampersand separated query string
     */
    buildQueryString(queryParams) {
        let queryChunks = [];
        Object.keys(queryParams).map(key => {
            queryChunks.push(key + '=' + queryParams[key]);
        });

        return queryChunks.join('&');
    },

    getRetrieveProductsForAgent() {
        let oauth = this.getAgentKeyAndSecret();
        let envConfig = this.getConfigForHost();
        let url = envConfig.getProductsForAgent.url;

        // generate the oauth without the query param URL
        let oauthQueryParams = this.generateOauth1QueryParams(
            "GET",
            oauth.key,
            oauth.secret,
            envConfig.getProductsForAgent.url,
            envConfig.getProductsForAgent.queryParams);

        url += "?" + oauthQueryParams;
        url += "&" + this.buildQueryString(envConfig.getProductsForAgent.queryParams);

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url,
                crossDomain: true,
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                success: function(data) {
                    let sorting = globalConfig.productIdOrder;

                    // filter out any new products
                    data = data.filter(product => product.productId < 23);

                    let sorted = data.map(function(item) {
                        let n = sorting.indexOf(item.productId);
                        sorting[n] = '';
                        return [n, item];
                    }).sort().map(function(j) { return j[1]; });

                    resolve(sorted);
                },
                error: function() {
                    reject("RETRIEVE PRODUCTS FOR AGENT ERROR");
                }
            }).fail(function(){
                reject("RETRIEVE PRODUCTS FOR AGENT FAIL");
            });
        });
    },

    getDecodedAgentHash() {
        const hash = window.localStorage.getItem('agentHash');

        // Only decode if there is a hash
        if( ! window.uornorb(hash)) {
            let bytes = CryptoJS.AES.decrypt(atob(hash), globalConfig.app.mcryptSecret);
            let decodedHash = bytes.toString(CryptoJS.enc.Utf8);

            let hashComponents = decodedHash.split('&');

            let hashObject = {};

            hashComponents.map(v => {
                let queryParam = v.split('=');
                if (queryParam[1] == '') {
                    queryParam[1] = null;
                }
                hashObject[queryParam[0]] = queryParam[1];
            });

            return hashObject;
        } else {
            browserHistory.push('/error/no-auth');
        }
    },

    /**
     * run through all the files in the global file list and upload
     * the equivalent blob.
     * once a file is uploaded, mark that file as uploaded in the duplicate
     * file list so we dont upload duplicates
     * @return {[type]} [description]
     */
    sendFilesForApplication(fileUploadedFunc) {
        let files = JSON.parse(window.localStorage.getItem('GlobalFileList'));

        // if no files, just resolve out
        if (window.uorn(files) || files == []) {
            return Promise.resolve(true);
        }

        // filter out uploaded files
        files = files.filter(f => {
            return (f.isUploaded !== true);
        });

        const blobPromises = files.map(file => {
            return blobUtil.base64StringToBlob(window.localStorage.getItem(file.name + '_blob'));
        });

        return Promise.all(blobPromises)
        .then((blobs) => {
            return blobs.map((blob, i) => {
                const file = files[i];
                const newFile = new File([blob], file.name);
                return this.postUploadDocument(file.applicationId, newFile, file.contextInfo).then(() => {
                    if (fileUploadedFunc) {
                        fileUploadedFunc(file);
                    }
                    Quote.setByPath('GlobalFileList.' + i + '.isUploaded', true);
                    return Promise.resolve(true);
                });
            });
        })
        .catch(() => {
            browserHistory.push('/error/file-upload-failed');
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/Managers/HttpService.js